import { render, staticRenderFns } from "./resources-dictionary-edit-modal.vue?vue&type=template&id=5bc27472&scoped=true"
import script from "./resources-dictionary-edit-modal.vue?vue&type=script&lang=js"
export * from "./resources-dictionary-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./resources-dictionary-edit-modal.vue?vue&type=style&index=0&id=5bc27472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc27472",
  null
  
)

export default component.exports